function game_5000()
{

}

game_5000.odd_map  = {
  "F":[0,0,15,150,250],
  "E":[0,0,15,100,200],
  "D":[0,0,10,50,200],
  "C":[0,0,10,30,120],
  "B":[0,0,5,15,75],
  "A":[0,0,5,10,30],
  "K":[0,0,5,10,30],
  "Q":[0,0,5,10,30],
  "J":[0,0,5,10,30],
  "T":[0,0,5,10,30],
};

export {
  game_5000
};



// WEBPACK FOOTER //
// ./src/components/slots/game_5000.js